export default __webpack_public_path__ + "static/media/SunIcon.cca71bb9.svg";